import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createDasAlertUrl } from "../../../../config";
import { Status } from "../../../../common/constants";
import api from '../../../../api';
import { RootState } from "../../../../store"; 
import { IInitialSliceState } from "../../../../common/types/commonTypes";

const CREATE_DAS: string = "createDas"

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
};

export const createDas = createAsyncThunk(CREATE_DAS, async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(createDasAlertUrl,payload);
      return response.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const createDasSlice = createSlice({
  name: CREATE_DAS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createDas.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(createDas.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(createDas.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.createDasApi;

export default createDasSlice.reducer;